import { FC } from 'react';
import { clsx } from 'clsx';
import styles from './SkeletonItem.css';
import { SkeletonRect } from '../SkeletonRect';

interface ISkeletonItemProps {
  isWide: boolean;
}

export const SkeletonItem: FC<ISkeletonItemProps> = ({ isWide }) => {
  return (
    <div className={styles['skeleton-item']}>
      <div className={clsx(styles['gallery'], isWide && styles['gallery--wide'])}>
        {/** Фото */}
        <SkeletonRect height="100%" style={{ height: '100%' }} className={styles['photo']} />

        {/** Миниатюры фото */}
        {isWide && (
          <div className={styles['thumbnails']}>
            <SkeletonRect height={78} />
            <SkeletonRect height={78} />
            <SkeletonRect height={78} />
          </div>
        )}
      </div>

      <div className={styles['content']}>
        {/** Заголовок и подзаголовок */}
        <SkeletonRect height={28} className={styles['title']} />
        <SkeletonRect height={22} className={styles['subtitle']} />

        {/** Лейбл */}
        <SkeletonRect width={160} height={24} className={styles['label']} />

        {/** Гео */}
        <div className={styles['geo']}>
          <SkeletonRect height={20} className={styles['geo-item']} />
          <SkeletonRect height={20} className={styles['geo-item']} />
          <SkeletonRect height={20} className={styles['geo-item']} />
        </div>

        {/** Цена и инфа по цене */}
        <SkeletonRect width={140} height={24} className={styles['price']} />
        <SkeletonRect width={140} height={22} className={styles['price-info']} />

        {/** Описание */}
        <SkeletonRect height={79} className={styles['description']} />
      </div>

      <div className={styles['publisher']}>
        {/** Аватарка */}
        <SkeletonRect borderRadius="50%" width={64} height={64} className={styles['avatar']} />

        {/** Тип автора */}
        <SkeletonRect height={16} className={styles['agent-type']} />
        {/** Имя автора */}
        <SkeletonRect height={24} className={styles['name']} />

        {/** Объявки автора */}
        <SkeletonRect height={20} className={styles['more-offers']} />

        {/** Кнопка звонка */}
        <SkeletonRect height={28} className={styles['phone-button']} />
        {/** Кнопка чата */}
        <SkeletonRect height={28} className={styles['chat-button']} />
      </div>
    </div>
  );
};
